/**
 * ReminderContainer Component
 * Wraps the app and displays active reminders
 */

import React from 'react';
import { useReminder } from '../context/ReminderContext';
import ReminderDisplay from './ReminderDisplay';

const ReminderContainer = ({ children }) => {
  const { activeReminder, preferences, dismissReminder, dismissAllReminders, activeInstancesCount, snoozeReminder } = useReminder();

  return (
    <>
      {children}
      {activeReminder && (
        <ReminderDisplay
          reminder={activeReminder}
          preferences={preferences}
          onDismiss={dismissReminder}
          onDismissAll={dismissAllReminders}
          activeInstancesCount={activeInstancesCount}
          onSnooze={snoozeReminder}
        />
      )}
    </>
  );
};

export default ReminderContainer;
